import { render, staticRenderFns } from "./OA.vue?vue&type=template&id=15bba276&scoped=true&"
import script from "./OA.vue?vue&type=script&lang=js&"
export * from "./OA.vue?vue&type=script&lang=js&"
import style0 from "./OA.vue?vue&type=style&index=0&id=15bba276&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bba276",
  null
  
)

export default component.exports